import { ITenant } from '../pages/AbmLocalPage/types'
import { axiosInstanceMain } from '../utils/axiosGlobalUtils'
import { hash } from '../utils/hashFunction'

export const registrarToken = async (
  user: any,
  token: string,
  imei: any,
  tenant: ITenant,
  deviceId: string,
  agente: string
) => {
  const clave = await hash(imei + 'lugares2017')
  const data = {
    rol: user.roles[0],
    pushToken: token,
    platform: 'web',
    dispositivoDesc: agente,
    clave
  }

  const res = await axiosInstanceMain.put(`/${tenant.path}/dispositivo/${deviceId}`, data)

  return res
}

export const autoRegistrarToken = async (codLocal: any, imei: any, tenant: ITenant) => {
  const res = await axiosInstanceMain.post(
    `/${tenant.path}/auth/registrar-autologin-local/${codLocal}?deviceId=${imei}`
  )

  return res
}

export const getDeviceId = async (tenant: ITenant) =>
  await axiosInstanceMain.get(`/${tenant.path}/dispositivo/nuevo-deviceid`)
